<template>
  <div class="login-footer">
      <div class="login-contact">
        <button class="login-footer-button" @click="switchqr">{{ $t('Auth.aboutUs') }}</button>
        <button class="login-footer-button" @click="contactUs">{{ $t('Auth.contactUs') }}</button>
        <label class="login-footer-label">{{ $t('Auth.copyRight') }}</label>
      </div>
      <div v-if="showqrcode">
        <a @click="close" class="close-qr">x</a>
        <img class="qrcode" src="../../assets/qrcode.jpg">
      </div>
  </div>
</template>
<script>
import Vue from 'vue'
const Footer = Vue.extend({
  name: 'Footer',
  data: function () {
    return {
      showqrcode: false
    }
  },
  mounted () {
  },
  methods: {
    contactUs () {
      this.$router.push({
        name: 'contactUs'
      })
    },
    switchqr () {
      this.showqrcode = !this.showqrcode
    },
    show () {
      this.showqrcode = true
      this.pre = true
    },
    close () {
      if (this.showqrcode === true) {
        this.showqrcode = false
      }
    }
  }
})
export default Footer
</script>

<style lang='scss' scoped>
.login-footer-button {
    background: none;
    border: 0;
    margin-left: 20px;
    transform: translateX(45px);
    width: fit-content;
    color: white;
}
.login-footer-button:focus {
  border: none;
}
.login-footer-label {
    margin-left: 600px;
    color: white;
    width: fit-content;
}
.login-footer {
    width: 1024px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}
.qrcode {
  position: fixed;
  left: 0%;
  transform: translateY(-120%);
  z-index: 99;
}
.close-qr {
  position: fixed;
  transform: translate(-150%, -820%);
  z-index: 100;
  font-size: 50px;
}
a{
  color: black;
  text-decoration:none;
  cursor: pointer;
}
</style>
